import {
  Permiso,
  Rol,
} from "@/pages/role-asignation/schema/role-assignation.schema";
import { createContext } from "react";

interface RolesContextType {
  userPermissions?: Permiso[] | null;
  loadingPermissions: boolean;
  fetchAllRoles: () => Promise<{
    listado: Rol[];
  }>;
  permissionList: string[];
  fetchPermissions: (load?: boolean) => Promise<void>;
}

export const RolesContext = createContext<RolesContextType | undefined>({
  userPermissions: null,
  loadingPermissions: false,
  fetchAllRoles: () =>
    Promise.resolve({
      listado: [],
    }),
  permissionList: [],
  fetchPermissions: (_load?: boolean) => Promise.resolve(),
});
